document.addEventListener("DOMContentLoaded", () => {
  const path = window.location.pathname;
  const isTransparentPage = path === "/" || path === "/pages/about";
  if (!isTransparentPage) return;

  const header = document.querySelector(".atd-section-header");
  const utilityBar = document.querySelector(".atd-announcement-bar-section");
  const nav = document.getElementById("atd-header");
  const headerDrawerDetails = document.querySelector("header-drawer details");

  if (!header || !utilityBar || !nav || !headerDrawerDetails) return;

  header.classList.add("sticky-navbar");
  utilityBar.classList.add("sticky-utility-bar");

  let utilityClosed = false;
  let isSticky = false;
  let threshold = window.innerWidth >= 1102 ? 180 : 160;

  function getThreshold() {
    return window.innerWidth >= 1102 ? 180 : 160;
  }

  window.addEventListener("utility-bar-close", () => {
    utilityClosed = true;
    header.classList.add("top-0");
  });

  // ── Scroll / sticky logic ─────────────────────────────
  let ticking = false;

  function updateNav(force = false) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const shouldBeSticky = scrollTop > threshold;

    if (force || shouldBeSticky !== isSticky) {
      isSticky = shouldBeSticky;

      // Only remove transparent-header if menu is not opening
      const menuOpen = headerDrawerDetails.classList.contains("menu-opening");

      nav.classList.toggle("transparent-header", !isSticky && !menuOpen);
      header.classList.toggle("sticky-header", isSticky);

      if (!utilityClosed) {
        header.classList.toggle("top-0", isSticky);
      }
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateNav);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener(
    "resize",
    () => {
      threshold = getThreshold();
      onScroll();
    },
    { passive: true },
  );

  // ── Initial state setup ─────────────────────────────
  requestAnimationFrame(() => updateNav(true));

  // ── Watch for menu-opening class ────────────────────
  const observer = new MutationObserver(() => {
    const menuOpen = headerDrawerDetails.classList.contains("menu-opening");
    if (menuOpen) {
      // remove transparent-header immediately
      nav.classList.remove("transparent-header");
    } else {
      // reapply if within scroll threshold
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= threshold) {
        nav.classList.add("transparent-header");
      }
    }
  });

  observer.observe(headerDrawerDetails, {
    attributes: true,
    attributeFilter: ["class"],
  });
});
